import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SignatureCanvas from 'react-signature-canvas';
import closeIcon from 'assets/images/icons/cross-grey.svg';

const SignatureField = ({ name, displayName, classes, onChange, existingSignature, required }) => {
  const { t } = useTranslation();
  let sigPad = useRef(null);

  const onDraw = () => {
    onChange(sigPad.current.toDataURL());
  };
  const onClear = () => {
    sigPad.current.clear();
    onChange('');
  };

  useEffect(() => {
    // For preview existing signature
    if (existingSignature && sigPad.current) {
      const canvas = sigPad.current.getCanvas();
      const context = canvas.getContext('2d');

      const img = new Image();
      img.onload = () => {
        // Clear current canvas
        sigPad.current.clear();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        // Target max image size = 80% of canvas dimensions
        const maxWidth = canvasWidth * 0.8;
        const maxHeight = canvasHeight * 0.8;
        const widthRatio = maxWidth / img.width;
        const heightRatio = maxHeight / img.height;
        const scale = Math.min(widthRatio, heightRatio);
        const finalWidth = img.width * scale;
        const finalHeight = img.height * scale;
        const x = (canvasWidth - finalWidth) / 2;
        const y = (canvasHeight - finalHeight) / 2;
        context.drawImage(img, x, y, finalWidth, finalHeight);
      };
      img.src = existingSignature;
    }
  }, [existingSignature]);

  return (
    <div className={`custom-input-box${classes ? ' ' + classes : ''}`}>
      {displayName && (
        <label htmlFor={name}>
          {t(displayName)}
          {required && <span className='lh-1 theme-size-1_5 theme-text-red-1 px-1'>*</span>}
        </label>
      )}
      <div className='custom-input-field signature-container theme-height-300 w-100'>
        <SignatureCanvas
          canvasProps={{ className: 'w-100 h-100' }}
          ref={(ref) => {
            sigPad.current = ref;
          }}
          onEnd={() => onDraw()}
        />
        <img className='signature-cross' src={closeIcon} onClick={() => onClear()} />
      </div>
    </div>
  );
};

SignatureField.propTypes = {
  name: PropTypes.string.isRequired,
  existingSignature: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  onSignatureDraw: PropTypes.string,
  classes: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

export default SignatureField;
